module.exports = __webpack_public_path__ + "videos/hero_en.4f6fea5.mp4";